//Icon Imports
import arrowLeftIcon from '../assets/icons/arrow-left.svg'
import arrowNarrowUpRightIcon from '../assets/icons/arrow-narrow-up-right.svg'
import arrowRightIcon from '../assets/icons/arrow-right.svg'
import arrowUpRightIcon from '../assets/icons/arrow-up-right.svg'
import bellIcon from '../assets/icons/bell.svg'
import boldCloseIcon from '../assets/icons/bold-close.svg'
import calendarIcon from '../assets/icons/calendar.svg'
import carFrontIcon from '../assets/icons/car.svg'
import checkCircleIcon from '../assets/icons/check-circle.svg'
import checkboxCheckedIcon from '../assets/icons/checkbox-checked.svg'
import checkboxUncheckedCircleIcon from '../assets/icons/checkbox-unchecked-circle.svg'
import checkboxUncheckedErrorIcon from '../assets/icons/checkbox-unchecked-error.svg'
import checkboxUncheckedIcon from '../assets/icons/checkbox-unchecked.svg'
import closeIcon from '../assets/icons/close.svg'
import currencyDollarCircleIcon from '../assets/icons/currency-dollar-circle.svg'
import dotsHorizontal from '../assets/icons/dots-horizontal.svg'
import emailBoxIcon from '../assets/icons/email-box.svg'
import FailureAlertIconSimple from '../assets/icons/failure-alert-icon-simple.jsx'
import FailureAlertIcon from '../assets/icons/failure-alert-icon.jsx'
import FailureToastIcon from '../assets/icons/failure-toast-icon.jsx'
import fastenTextLogoWhite from '../assets/icons/fasten-logo-yellow.svg'
import fastenTextLogoBlueYellow from '../assets/icons/fasten-text-logo-blue-yellow.png'
import featuredOneIcon from '../assets/icons/featured-icon-one.svg'
import featuredThreeIcon from '../assets/icons/featured-icon-three.svg'
import featuredTwoIcon from '../assets/icons/featured-icon-two.svg'
import filterIcon from '../assets/icons/filter-lines.svg'
import grayCheckboxCheckedIcon from '../assets/icons/gray-checkbox-checked.svg'
import grayIndicatorIcon from '../assets/icons/gray-indicator.svg'
import grayNotificationIcon from '../assets/icons/gray-notification.svg'
import greenCheckIcon from '../assets/icons/green-check.svg'
import helpBoldIcon from '../assets/icons/help-bold.svg'
import helpIcon from '../assets/icons/help.svg'
import logoutIcon from '../assets/icons/logout.svg'
import menuIcon from '../assets/icons/menu.svg'
import plusIcon from '../assets/icons/plus.svg'
import roundedGrayMinusIcon from '../assets/icons/rounded-gray-minus.svg'
import roundedGrayPlusIcon from '../assets/icons/rounded-gray-plus.svg'
import searchIcon from '../assets/icons/search.svg'
import SuccessToastIcon from '../assets/icons/success-toast-icon.jsx'
import userIcon from '../assets/icons/user.svg'
import UserCircleAvatarIcon from '../assets/icons/UserCircleAvatar'
import xCircleIcon from '../assets/icons/x-circle.svg'
import fastenTextLogoBlack from '../assets/images/fasten-text-logo-black.svg'


//Icon Exports
export const Icons = {
  carFrontIcon,
  closeIcon,
  featuredOneIcon,
  featuredTwoIcon,
  featuredThreeIcon,
  roundedGrayPlusIcon,
  roundedGrayMinusIcon,
  helpIcon,
  grayIndicatorIcon,
  searchIcon,
  userIcon,
  bellIcon,
  menuIcon,
  boldCloseIcon,
  logoutIcon,
  helpBoldIcon,
  filterIcon,
  greenCheckIcon,
  calendarIcon,
  plusIcon,
  arrowLeftIcon,
  arrowRightIcon,
  arrowNarrowUpRightIcon,
  arrowUpRightIcon,
  currencyDollarCircleIcon,
  xCircleIcon,
  checkCircleIcon,
  SuccessToastIcon,
  FailureToastIcon,
  grayNotificationIcon,
  FailureAlertIcon,
  FailureAlertIconSimple,
  fastenTextLogoBlack,
  checkboxCheckedIcon,
  grayCheckboxCheckedIcon,
  checkboxUncheckedIcon,
  checkboxUncheckedErrorIcon,
  checkboxUncheckedCircleIcon,
  emailBoxIcon,
  UserCircleAvatarIcon,
  fastenTextLogoWhite,
  fastenTextLogoBlueYellow,
  dotsHorizontal,
}

